import Card from '@commons/components/Card';
import Icon from '@commons/components/Icon';
import DrupalImage from '@commons/components/Image/Drupal';
import LoadingSkeleton from '@commons/components/LoadingSkeleton';
import RichText from '@commons/components/RichText';
import Separator from '@commons/components/Separator';
import Flex from '@commons/containers/Flex';
import { Link } from '@commons/i18n/navigation';
import type { MemberNodeProps } from '@commons/pagebuilder/nodes/Member';
import { CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import styles from './Card.module.scss';

/**
 * AiiA Member node card component.
 */

export const MemberNodeCard = ({ alias, title, headshot, position, linkedIn }: MemberNodeProps) => (
  <Card hasBorder justify="start" direction={{ xs: 'row', md: 'column' }} className={styles.card}>
    <Link
      href={alias || '#'}
      title={title}
      scroll={false}
      aria-label={title}
      className={styles.cardLink}
    >
      {''}
    </Link>
    <Card.Overlay>
      <DrupalImage {...headshot} className={styles.headshot} sizes={CARD_DISPLAY_IMAGE_SIZES} />
    </Card.Overlay>
    <Flex
      gap="xs"
      width={12}
      align="start"
      direction="column"
      justify="space-between"
      className="h-100"
    >
      <Flex gap="xs" direction="column">
        <Card.Title>{title}</Card.Title>
        <RichText value={position} />
      </Flex>
      {linkedIn && (
        <Flex.Item>
          <Link
            href={linkedIn.url}
            className={styles.linkedInLink}
            aria-label={`LinkedIn: ${title}`}
          >
            <Icon type="linkedin" className={styles.linkedIn} />
          </Link>
        </Flex.Item>
      )}
    </Flex>
  </Card>
);

/**
 * Loading member node card component.
 */

export const LoadingMemberNodeCard = () => (
  <Card hasBorder direction={{ xs: 'row', lg: 'column' }} className={styles.card}>
    <LoadingSkeleton className={styles.headshot} />
    <Flex gap="xs" width={12} direction="column">
      <Separator dash color="primary" />
      <LoadingSkeleton width="80%" />
      <LoadingSkeleton width="60%" />
    </Flex>
  </Card>
);

export default MemberNodeCard;
